//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.FBM.js";
import "../CAM/CAM.Geometry.js";
import "../no/ugmath.js";
import "../no/CAM.js";
let d=[[[0,"UseModelDepth",1,0]],[[[],"CreateFeatureSet",{R_:{ppFeatureBuilder:"CAM.FBM.FeatureSet"}},0,0],[["tagMachiningFeature","featureType"],"AddFeatureSet",{R_:{ppFeatureBuilder:"CAM.FBM.FeatureSet"}},2,0],[["nIndex"],"GetFeatureSet",{R_:{ppFeatureBuilder:"CAM.FBM.FeatureSet"}},1,0],[["attributeName","dValue"],"SetDefaultAttributeDouble",{},2,0],[["attributeName","strValue"],"SetDefaultAttributeString",{},2,0],[["attributeName","nValue"],"SetDefaultAttributeInt",{},2,0],[["attributeName","bValue"],"SetDefaultAttributeLogical",{},2,0],[["sortType"],"ReorderFeatures",{},1,0],[["direction","pattern","vecValue"],"ReorderFeaturesByDirection",{},3,0],[["direction","pattern","vecValue","bandWidth"],"ReorderFeaturesByDirection1",{},4,0],[[],"ReverseFeatures",{},0,0],[[],"ReloadList",{},0,0],[["machiningArea"],"SetMachiningArea",{},1,0],[[],"GetMachiningArea",{R_:{machiningArea:''}},0,0],[["objects","featureType","num_features"],"CreateFeatures",{R_:{features:"CAM.FBM.Feature[]"}},2,0]],[]];
SPLM.CAM.FBM.FeatureGeometry = class extends SPLM.CAM.Geometry{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.FBM.FeatureGeometry";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.FBM.FeatureGeometry.SortOrder = Object.freeze({
    "Closest" : "Closest", "ShortestPath" : "ShortestPath", "PrimaryDirection" : "PrimaryDirection"});

SPLM.CAM.FBM.FeatureGeometry.SequenceDirectionType = Object.freeze({
    "Xm" : "Xm", "Ym" : "Ym", "Zm" : "Zm", "Vector" : "Vector"});

SPLM.CAM.FBM.FeatureGeometry.SequencePatternType = Object.freeze({
    "Zig" : "Zig", "ZigZag" : "ZigZag"});

export default SPLM;